import { IItinerary } from "@thekilroygroup/shared-ui";
import { IPriceItinerary } from "./interfaces.lowPrice";

export const getSelectedItineraryDates = (
  selectedItinerary: IItinerary | undefined | null,
) => {
  if (!selectedItinerary) return null;

  return {
    departureDate: selectedItinerary.flights[0].departureDateTime.substring(
      0,
      10,
    ),
    returnDate: selectedItinerary.flights[1].departureDateTime.substring(0, 10),
  };
};

export const removeDublicatedEntries = (
  nextCheapestCombinations: IPriceItinerary[],
  cheapestCombinations: IPriceItinerary[],
) => {
  const merged: IPriceItinerary[] = [
    ...cheapestCombinations,
    ...nextCheapestCombinations,
  ];

  const unique = merged.filter(
    (thing, index, self) =>
      index ===
      self.findIndex(
        (t) =>
          t.departureDate === thing.departureDate &&
          t.returnDate === thing.returnDate,
      ),
  );

  return unique;
};
